import { promoteInlineTask, type Task } from '@nexus/workspace';
import type { Store } from '@nexus/store';
import { useUi } from '../../state/ui';

/** Make a task page of a checkbox task and open it. */
export async function promoteTask(store: Store, task: Pick<Task, 'id' | 'pageId'>) {
  const page = await promoteInlineTask(store, task);
  if (page) useUi.getState().open({ kind: 'page', pageId: page.id });
}
